<template>
  <div ref="container" class="stickers-widget">
    <Stickers
      always-enabled
      :container="container"
      :style="stickersStyle"
      @click="displayStickers"
      @closeClick="hideStickers"
    />
  </div>
</template>

<script>
/**
 * Text widget. Allows the user to type in whatever he wants during configuration
 */

// Import components
import Stickers from '@/components/stickers.vue';
import mixinWidgets from '@/mixins/widgets.vue';
import mixinWidgetsBgColor from '@/mixins/widgets-bgcolor-config.vue';
// Import utils
import { getTextFgColor } from '@/utils/main';

export default {
  name: 'StickersWidget',
  components: {
    Stickers,
  },
  mixins: [mixinWidgets, mixinWidgetsBgColor],
  props: {
  },
  data() {
    return {
      stickersStyle: {},
      stickersDisplayed: false,
    };
  },
  computed: {
    config() {
      return [
        this.defaultBgColorConfig,
      ];
    },
    blueTextStyle() {
      return { color: getTextFgColor(this.designOptions.bgColor, '#2A5A91') };
    },
  },
  watch: {
    currentTeamPlans() {
      if (!this.plansLoading && !this.managedPlansLoading) {
        this.$nextTick(this.refreshUsers);
      }
    },
    managedPlans(isLoading) {
      if (!this.plansLoading && !this.managedPlansLoading) {
        this.$nextTick(this.refreshUsers);
      }
    },
  },
  mounted() {
    this.resize();
  },
  methods: {
    refresh() {
      this.resize();
    },
    sizeChanged() {
      this.resize();
    },
    resize() {
      const el = this.$refs.container;
      if (el) {
        const { offsetWidth, offsetHeight } = el;
        const margin = 5;
        const size = Math.min(offsetWidth, offsetHeight) - margin * 2;
        this.stickersStyle = {
          width: `${size}px`,
          paddingTop: `${size}px`,
          margin: `${margin}px`,
        };
      }
    },
    /** Show a stickers container at the top right corner */
    displayStickers() {
      this.stickersDisplayed = true;
      this.$refs.stickers.enableDrag(this.$refs.fwContent);
    },
    /** Hide the stickers container */
    hideStickers() {
      this.stickersDisplayed = false;
      this.$refs.stickers.disableDrag();
    },
  },
};

</script>

<style lang="scss">
.stickers-widget.widget-component-child {
  overflow: visible;

  .w-stickers .content .close {
    z-index: initial;
  }
  .sticker-col .sticker .colored-sticker {
    z-index: initial;
  }
}
</style>
